// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextType from '../TextType/TextType';
import CheckboxType from '../CheckboxType/CheckboxType';
import RadioButtonType from '../RadioType/RadioType';
import Drawer from '../../Drawer/Drawer';
import classNames from 'classnames/bind';
import { countTags } from '../utils';
import { FormattedMessage } from 'react-intl';
import RangeType from '../RangeType/RangeType';

import filterStyle from '../Filter.scss';
import style from './FilterDrawer.scss';
import icons from '../../../assets/styles/icons.scss';

import type { FilterField } from '../Filter';

type Props = {
  +filterFields: FilterField[];
  +drawerOpen: boolean;
  +handleCloseDrawer: () => void;
  +handleOpenDrawer: () => void;
  +handleClearFilters: () => void;
  +color?: 'lightBlue' | 'orange';
};

export default class FilterDrawer extends Component<Props> {
  render() {
    const { filterFields, drawerOpen, handleCloseDrawer, handleOpenDrawer, handleClearFilters, color } = this.props;
    const content = filterFields.map((filterField: FilterField, n: number) => {
      const field = [];
      switch (filterField.type) {
        case 'text':
          field.push(<TextType key={`${n}-${Math.round(Math.random() * 10000)}`}
                               filterField={(filterField: any)}/>);
          break;
        case 'checkbox':
          field.push(<CheckboxType key={`${n}-${Math.round(Math.random() * 10000)}`}
                                   filterField={(filterField: any)}/>);
          break;
        case 'radio':
          field.push(<RadioButtonType key={`${n}-${Math.round(Math.random() * 10000)}`}
                                      filterField={(filterField: any)}/>);
          break;
        case 'range':
          field.push(<RangeType key={`${n}-${Math.round(Math.random() * 10000)}`}
                                filterField={(filterField: any)}/>);
          break;
      }
      if (n !== filterFields.length - 1) {
        field.push(<hr className={style.hr}
                       key={`${n}-${Math.round(Math.random() * 10000)}`}/>);
      }
      return field;
    });
    const count = countTags(filterFields) || 0;
    return [
      <FormattedMessage key={'title'}
                        id="filter.title">{
        txt => <button onClick={handleOpenDrawer}><i className={icons.symbolTweak}/>{txt}{/*({count})*/}</button>
      }</FormattedMessage>,
      <Drawer key='drawer'
              open={drawerOpen}
              handleClickOutside={handleCloseDrawer}>
        <section className={classNames(style.drawerWrap, filterStyle.filterWrap)}>
          <article className={style.top}>
            <FormattedMessage id="filter.title">{
              txt => <h3 className={style.title}>{txt}</h3>
            }</FormattedMessage>
            <FormattedMessage id="filter.ready">{
              txt => <button className={classNames(style.ready, {
                [style.lightBlue]: !color || color === 'lightBlue',
                [style.orange]: color === 'orange',
              })}
                             onClick={handleCloseDrawer}>{txt}</button>
            }</FormattedMessage>
          </article>
          <article className={classNames(filterStyle.content, style.content)}>{content}</article>
          {/*<article className={style.bottom}>
            <FormattedMessage id="filter.clean">{
              txt => <button className={style.clean}
                             onClick={handleClearFilters}>{txt}</button>
            }</FormattedMessage>
          </article>*/}
        </section>
      </Drawer>];
  }
}

FilterDrawer.propTypes = {
  filterFields: PropTypes.array.isRequired,
  drawerOpen: PropTypes.bool.isRequired,
  handleCloseDrawer: PropTypes.func.isRequired,
  handleOpenDrawer: PropTypes.func.isRequired,
  handleClearFilters: PropTypes.func.isRequired,
  color: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/elements/Filter/Drawer/FilterDrawer.jsx